import { createSlice } from "@reduxjs/toolkit";

export const DASHBOARD_SLICE = "dashboard"
const dashboardSlice = createSlice({
    name: DASHBOARD_SLICE,
    initialState: {
        isLoading: false,
        employeeGroupByGender: [],
        employeeGroupByType: [],
        employeeGroupInfoByCompany: [],
        employeeSalaryByBranch: [],
        separationList: [],
        newEmployee: {},
        payrollPeriodYearRaw: [],
        payrollPeriodYearRawPrevYear: [],
    },
    reducers: {
        setIsLoading(state, action) {
            state.isLoading = action.payload;
        },
        setEmployeeGroupByGender(state, action) {
            state.employeeGroupByGender = action.payload;
        },
        setEmployeeGroupByType(state, action) {
            state.employeeGroupByType = action.payload;
        },
        setEmployeeGroupInfoByCompany(state, action) {
            state.employeeGroupInfoByCompany = action.payload;
        },
        setEmployeeSalaryByBranch(state, action) {
            state.employeeSalaryByBranch = action.payload;
        },
        setSeparation(state, action) {
            state.separationList = action.payload;
        },
        setNewEmployee(state, action) {
            state.newEmployee = action.payload;
        },
        setPayrollPeriodYearRaw: (state, action) => {
            state.payrollPeriodYearRaw = action.payload;
        },
        setPayrollPeriodYearRawPrevYear: (state, action) => {
            state.payrollPeriodYearRawPrevYear = action.payload;
        },
    },
});

export const {
    setIsLoading,
    setEmployeeGroupByGender,
    setEmployeeGroupByType,
    setEmployeeGroupInfoByCompany,
    setNewEmployee,
    setEmployeeSalaryByBranch,
    setPayrollPeriodYearRaw,
    setPayrollPeriodYearRawPrevYear,
    setSeparation
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
